import React, { useState } from "react";
import styles from "./PlaydateInviteRecipientView.module.css";
import {
    PlaydateInvite,
} from "../../../gql/types";
import ActionButton from "../../button/ActionButton";
import UnderlineButton from "../../button/UnderlineButton";
import PlaydateInviteBaseView from "./PlaydateInviteBaseView";
import PlaydateInviteFullDetails from "../PlaydateInviteFullDetails";
import { renderCollapsibleSection } from "./PlaydateInviteOrganizerInPlanningView";
import PlaydateInviteResponseList from "../PlaydateInviteResponseList";

export type PlaydateInviteConfirmedOrganizerViewProps = {
    onBack: () => void;
    onCancel: () => void;
    onCreate?: () => void;
    invite: PlaydateInvite;
    baseZIndex?: number;
};

const PlaydateInviteConfirmedOrganizerView: React.FC<PlaydateInviteConfirmedOrganizerViewProps> = ({
    onBack,
    onCancel,
    onCreate,
    invite,
    baseZIndex,
}) => {
    const [isDetailsOpen, setIsDetailsOpen] = useState(false);
    const [isGuestListOpen, setIsGuestListOpen] = useState(true);

    const infoText = invite.expired
        ? "Hope you had a great playdate! You can view the responses and details here."
        : "View the invite details and see who's joining you!";

    return (
        <PlaydateInviteBaseView
            baseZIndex={baseZIndex}
            onBack={onBack}
            title="Playdate Invite Details"
            infoText={infoText}
            topIcon="happy"
        >
            {renderCollapsibleSection({
                title: "Guests:",
                isOpen: isGuestListOpen,
                onToggle: () => setIsGuestListOpen(prev => !prev),
                content: <PlaydateInviteResponseList inviteResponses={invite.responses ?? []} />,
            })}

            {renderCollapsibleSection({
                title: "Playdate Details:",
                isOpen: isDetailsOpen,
                onToggle: () => setIsDetailsOpen(prev => !prev),
                content: <PlaydateInviteFullDetails invite={invite} />,
            })}

            <div className={styles.buttonContainer}>
                {invite.expired ? (
                    onCreate ? (
                        <ActionButton onClick={onCreate}>
                            Create New Invite
                        </ActionButton>
                    ) : (
                        <ActionButton onClick={onBack}>
                            Back
                        </ActionButton>
                    )
                ) : (
                    <>
                        <ActionButton onClick={onBack}>
                            Back
                        </ActionButton>
                        <UnderlineButton onClick={onCancel}>
                            Cancel Invite
                        </UnderlineButton>
                    </>
                )}
            </div>
        </PlaydateInviteBaseView>
    );
};

export default PlaydateInviteConfirmedOrganizerView;
